import { render, staticRenderFns } from "./ERegistrationProfessionalRegisterView.vue?vue&type=template&id=468c5d1c&scoped=true&"
import script from "./ERegistrationProfessionalRegisterView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationProfessionalRegisterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c5d1c",
  null
  
)

export default component.exports